module.exports = __webpack_public_path__ + "static/media/playstore-4c.6e43d2ae.png";